var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "800",
      "title": `${_vm.openedReceive && _vm.openedType !== 'create' ? '编辑' : '新增'}回款记录`,
      "mask-closable": false,
      "transfer": false
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('Modal', {
    attrs: {
      "width": "800"
    },
    model: {
      value: _vm.isShowchooseBillModal,
      callback: function ($$v) {
        _vm.isShowchooseBillModal = $$v;
      },
      expression: "isShowchooseBillModal"
    }
  }, [_c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索简称...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchBankAccount
    },
    model: {
      value: _vm.searchBillText,
      callback: function ($$v) {
        _vm.searchBillText = $$v;
      },
      expression: "searchBillText"
    }
  })], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadBill
    }
  })], 1)]), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.billList,
      "height": _vm.tableHeight
    },
    on: {
      "on-row-click": _vm.chooseBill
    }
  })], 1)]), _c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "formItem"
  }, [_c('div', {
    staticClass: "formItem-left",
    style: _vm.formItemStyle
  }, [_c('FormItem', {
    attrs: {
      "label": "收款项目",
      "prop": "fromModel"
    }
  }, [_vm.openedReceive ? _c('div', [_vm._v(" " + _vm._s(_vm.fromModelToTextMethod(_vm.formItem.receiveItem)) + " ")]) : _c('RadioGroup', {
    on: {
      "on-change": _vm.changeFromModel
    },
    model: {
      value: _vm.formItem.receiveItem,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "receiveItem", $$v);
      },
      expression: "formItem.receiveItem"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "huokuan"
    }
  }, [_c('span', [_vm._v("客户货款")])]), _c('Radio', {
    attrs: {
      "label": "buzhu"
    }
  }, [_c('span', [_vm._v("政府补助")])]), _c('Radio', {
    attrs: {
      "label": "tuibzj"
    }
  }, [_c('span', [_vm._v("退保证金")])]), _c('Radio', {
    attrs: {
      "label": "yinhang"
    }
  }, [_c('span', [_vm._v("银行放款")])]), _c('Radio', {
    attrs: {
      "label": "gl-huokuan"
    }
  }, [_c('span', [_vm._v("关联公司收货款")])]), _c('Radio', {
    attrs: {
      "label": "gl-jiekuan"
    }
  }, [_c('span', [_vm._v("关联公司还借款")])]), _c('Radio', {
    attrs: {
      "label": "gl-others"
    }
  }, [_c('span', [_vm._v("关联公司的其他收款")])]), _c('Radio', {
    attrs: {
      "label": "others"
    }
  }, [_c('span', [_vm._v("其他")])])], 1)], 1), _vm.formItem.receiveItem !== 'others' ? _c('FormItem', {
    attrs: {
      "label": _vm.receiveLabel,
      "prop": "from"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.openedReceive || _vm.isPayToDisabled ? true : false,
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.customerLoading,
      "placeholder": _vm.placeholder
    },
    on: {
      "on-change": _vm.selectedCustomer
    },
    model: {
      value: _vm.formItem.from,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "from", $$v);
      },
      expression: "formItem.from"
    }
  }, _vm._l(_vm.payToList, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "366px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1) : _vm._e(), _c('FormItem', {
    attrs: {
      "label": "收款内容",
      "prop": "content"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "输入收款内容..."
    },
    model: {
      value: _vm.formItem.content,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "content", $$v);
      },
      expression: "formItem.content"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "收款公司",
      "prop": "company"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.chooseCompany
    },
    model: {
      value: _vm.formItem.company,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "company", $$v);
      },
      expression: "formItem.company"
    }
  }, _vm._l(_vm.companyList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "责任人",
      "prop": "receivedBy"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.receivedBy,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "receivedBy", $$v);
      },
      expression: "formItem.receivedBy"
    }
  }, _vm._l(_vm.simpleUserList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "创建人",
      "prop": "createdBy"
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.openedReceive ? _vm.openedReceive.createdBy ? _vm.openedReceive.createdBy.name : "" : _vm.user.name) + " ")])]), _c('FormItem', {
    attrs: {
      "label": "创建时间",
      "prop": "createdAt"
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.openedReceive ? _vm.openedReceive.createdAt : _vm.currentDate) + " ")])]), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "输入备注..."
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1)], 1), _c('div', {
    staticClass: "formItem-right",
    style: _vm.formItemStyle
  }, [_c('FormItem', {
    attrs: {
      "label": "收款账号",
      "prop": "bankAccount"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": _vm.disabled,
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.bankAccount,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "bankAccount", $$v);
      },
      expression: "formItem.bankAccount"
    }
  }, _vm._l(_vm.bankAccountList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.abbr))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "回款类型",
      "prop": "type"
    }
  }, [_vm.openedReceive && _vm.formItem.status != 'needConfirm' ? _c('div', [_vm._v(" " + _vm._s(_vm.typeText) + " ")]) : _c('RadioGroup', {
    on: {
      "on-change": _vm.changType
    },
    model: {
      value: _vm.receiveType,
      callback: function ($$v) {
        _vm.receiveType = $$v;
      },
      expression: "receiveType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "trans"
    }
  }, [_c('span', [_vm._v("银行转账")])]), _c('Radio', {
    attrs: {
      "label": "cash"
    }
  }, [_c('span', [_vm._v("现金钞票")])]), _c('Radio', {
    attrs: {
      "label": "bill"
    }
  }, [_c('span', [_vm._v("票据")])])], 1)], 1), _vm.isShowBillButton ? _c('div', {
    staticClass: "show-bill-button"
  }, [_c('Button', {
    staticClass: "createBill",
    attrs: {
      "type": "primary",
      "ghost": ""
    },
    on: {
      "click": _vm.openCreateNewBillDrawer
    }
  }, [_vm._v("创建新票据")]), _c('Button', {
    attrs: {
      "type": "primary",
      "ghost": ""
    },
    on: {
      "click": _vm.openChooseBillDrawer
    }
  }, [_vm._v("选择票据")])], 1) : _vm._e(), _vm.bill._id ? _c('div', {
    staticClass: "bill-card",
    on: {
      "click": _vm.openEditBillDrawer
    }
  }, [_c('Card', {
    staticStyle: {
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', {
          staticClass: "bill-list-title"
        }, [_c('div', [_vm._v(_vm._s(_vm.typeToTextMethod(_vm.bill.type)))]), _c('div', [_vm._v(_vm._s(_vm.bill.billNo))])])];
      },
      proxy: true
    }], null, false, 3590565960)
  }, [_c('div', {
    staticClass: "bill-content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.amountToLocaleString(_vm.bill.amount)) + "元")]), _c('div', [_vm._v(_vm._s(_vm.dateformatConversion(_vm.bill.billEndedAt)))]), _c('div', [_vm._v(_vm._s(_vm.bill.billCompany))]), _c('div', [_vm._v(_vm._s(_vm.bill.billBank))]), _c('div', [_vm._v(_vm._s(_vm.billStatusToTextMethod(_vm.bill.billStatus)))]), _c('div', [_vm._v(_vm._s(_vm.billTagsToTextMethod(_vm.bill.tags)))])])])], 1) : _vm._e(), _vm.openedReceive ? _c('FormItem', {
    attrs: {
      "prop": "submitAmount",
      "label": "业务员提交金额（元）"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.formItem.submitAmount ? _vm.formItem.submitAmount : "-"))])]) : _vm._e(), _c('FormItem', {
    attrs: {
      "label": "实际金额（元）",
      "prop": "amount"
    }
  }, [_vm.openedReceive && _vm.openedReceive.bill ? _c('div', [_vm._v(" " + _vm._s(_vm.formItem.amount) + " ")]) : _c('InputNumber', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: _vm.formItem.amount,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "amount", $$v);
      },
      expression: "formItem.amount"
    }
  }), _vm.openedReceive && _vm.openedReceive.bill ? _c('div', [_vm._v("以票据为准")]) : _vm._e()], 1), _c('FormItem', {
    attrs: {
      "label": "收到此现金或票据的日期",
      "prop": "receivedAt"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "placeholder": "选择到账日期"
    },
    on: {
      "on-change": _vm.changeReceivedAt
    },
    model: {
      value: _vm.formItem.receivedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "receivedAt", $$v);
      },
      expression: "formItem.receivedAt"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.formItem.status,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "status", $$v);
      },
      expression: "formItem.status"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "needConfirm"
    }
  }, [_c('span', [_vm._v("需财务确认")])]), _c('Radio', {
    attrs: {
      "label": "confirmed"
    }
  }, [_c('span', [_vm._v("已确认")])]), _c('Radio', {
    attrs: {
      "label": "rejected"
    }
  }, [_c('span', [_vm._v("财务拒绝")])]), _c('Radio', {
    attrs: {
      "label": "cancelled"
    }
  }, [_c('span', [_vm._v("业务员取消")])])], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "锁定",
      "prop": "isLocked"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.isLocked,
      callback: function ($$v) {
        _vm.isLocked = $$v;
      },
      expression: "isLocked"
    }
  }, _vm._l(_vm.isLockRadios, function (item) {
    return _c('Radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1)], 1)]), _c('div', {
    staticClass: "bottom-button"
  }, [_vm.openedType === 'needConfirm' ? _c('FormItem', {
    staticStyle: {
      "margin-left": "16px",
      "margin-bottom": "0"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.verifyAndUpdateReceive('formItem');
      }
    }
  }, [_vm._v("审核通过并保存")])], 1) : _vm._e(), _vm.openedType === 'confirmed' || _vm.openedType === 'needConfirm' || _vm.openedType === 'create' ? _c('FormItem', {
    staticStyle: {
      "margin-left": "16px",
      "margin-bottom": "0"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.handleSubmitLoading
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1) : _vm._e(), _vm.openedType === 'needConfirm' ? _c('FormItem', {
    staticStyle: {
      "margin-left": "16px",
      "margin-bottom": "0"
    }
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.refuseReceiveMethod('formItem');
      }
    }
  }, [_vm._v("拒绝")])], 1) : _vm._e(), _vm.openedType !== 'create' ? _c('FormItem', {
    staticStyle: {
      "margin-left": "16px",
      "margin-bottom": "0"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.copyNewReceive();
      }
    }
  }, [_vm._v("复制回款")])], 1) : _vm._e(), _c('FormItem', {
    staticStyle: {
      "margin-left": "16px",
      "margin-bottom": "0"
    }
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        _vm.drawerOpened = false;
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)])], 1), _c('AddBillDrawer', {
    ref: "AddBillDrawer",
    on: {
      "updateBill": _vm.updateBill
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }